import { Injectable } from '@angular/core';
import { catchError,map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { Observable, throwError } from 'rxjs';
import { Empresa, RequestResponseGetAllEmpresa, RequestResponseActualizar } from 'src/app/shared/models/empresas.interface';


@Injectable({
  providedIn: 'root'
})
export class EmpresaService {
  constructor(private http:HttpClient,private router: Router,private alert:AlertHelper) { }
  //GetAll_empresas
  traerEmpresas(): Observable<RequestResponse> {
    return this.http
    .get<RequestResponseGetAllEmpresa >(`${environment.API}/rrhh/empresa/`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //GetAll_empresasAsync
  async traerEmpresasAsync(): Promise<RequestResponse> {
    try {
      return this.http.get<RequestResponseGetAllEmpresa>(`${environment.API}/rrhh/empresa/`).toPromise();
    } catch (error) {
      console.error(error);
      return {success: false, msg: 'Hubo un error al obtener las empresas'} as RequestResponse;
    }
  }
  //GetAll_empresaC
  traerEmpresaCiudad(): Observable<RequestResponseGetAllEmpresa> {
    return this.http
    .get<RequestResponseGetAllEmpresa >(`${environment.API}/rrhh/empresa/ciudad`)
    .pipe(
      map((res:RequestResponseGetAllEmpresa) =>{          
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }

  //Create_empresa
  crearEmpresa(empresa:any): Observable<RequestResponse> {  
    return this.http
    .post<RequestResponse >(`${environment.API}/rrhh/empresa/crear`,empresa)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Obtener_empresa
  obtenerEmpresa(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/empresa/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Obtener_empresaAsync
  async obtenerEmpresaAsync(id:number): Promise<RequestResponse> {
    try {
      return this.http.get<RequestResponse>(`${environment.API}/rrhh/empresa/${id}`).toPromise();
    } catch (error) {
      console.error(error);
      return {success: false, msg: 'Hubo un error al obtener la empresa'} as RequestResponse;
    }
  }
  //Eliminar_empresa
  eliminarEmpresa(id:number): Observable<RequestResponse> {
    return this.http
    .delete<RequestResponse >(`${environment.API}/rrhh/empresa/eliminar/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Actualizar_empresa
  actualizarEmpresa(empresa:any): Observable<RequestResponseActualizar>  {
    return this.http
    .put<RequestResponseActualizar >(`${environment.API}/rrhh/empresa/actualizar/${empresa.id}`,empresa)
    .pipe(
      map((res:RequestResponseActualizar) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  

  private handlerError(err: any):Observable<never>{

    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }

}




